<template>
	<div class="form-group">
		<div class="flex flex-wrap">
			<div class="w-full md:w-1/2 pr-0 md:pr-4" v-if="!showOnly">
				<BaseSelect
					ref="BaseInput.licensePlateSelection"
					:required="required"
					@input="updateValue()"
					:label="$t('license_plate_kind')"
					:options="options"
					v-model="licensePlateSelection"
					:allow-empty="false"
					:disabled="disabled"
				/>
			</div>

			<div
				class="flex w-full md:mt-4 overflow-hidden license-input-box border-2 border-black rounded-md box-border"
				:class="{ 'md:w-1/2': !showOnly }"
				v-if="licensePlateSelection"
			>
				<div class="mr-4" v-if="!isSpecialPlate"><img src="@/assets/license_plate_background.jpg" class="h-24 max-w-none" alt="img" /></div>
				<div class="mr-4" v-if="isSpecialPlate"><img src="@/assets/license_plate_background_without_d.png" class="h-24 max-w-none" alt="img" /></div>
				<BaseInput
					ref="BaseInput.specialLicensePlate"
					v-if="this.isSpecialPlate"
					@input="updateValue"
					class="pr-2 mb-0 w-full mr-2 mt-4"
					label=""
					:placeholder="$t('special_plate')"
					type="text"
					v-model="specialLicensePlate"
					validation="[ÄÜÖäüöa-zA-Z0-9 ]{1,25}"
					mask="MMMMMMMMMMMMMMMMMMMMMMMMM"
					:required="required"
					:disabled="disabled"
				/>

				<div class="flex pr-4 w-full mt-4" style="align-items: start" v-else>
					<BaseInput
						ref="BaseInput.regularLicensePlate.firstPart"
						:required="required"
						@input="updateValue"
						label=""
						placeholder="DO"
						class=" mb-0 mr-2 w-full"
						type="text"
						maxlength="3"
						:error-message="$t('check_field')"
						v-model="regularLicensePlate.firstPart"
						validation="[ÄÜÖäüöa-zA-Z]{1,3}"
						mask="LLL"
						:disabled="disabled"
					/>
					<div
						class="justify-center align-middle items-center flex "
						style="align-items: center; text-align: center; width: fit-content; flex-direction: column"
					>
						<div class="border-black border rounded-full mb-1 h-4 w-4 justify-center" style="align-content: center; text-align: center"></div>
						<div class="border-black border rounded-full w-5 h-5 " style="align-self: center"></div>
					</div>
					<BaseInput
						ref="BaseInput.regularLicensePlate.secondPart"
						:required="required"
						@input="updateValue"
						label=""
						placeholder="AM"
						class="pr-2 mb-0 w-full ml-2"
						type="text"
						maxlength="2"
						:error-message="$t('check_field')"
						v-model="regularLicensePlate.secondPart"
						validation="[a-zA-Z]{1,2}"
						mask="AA"
						:disabled="disabled"
					/>
					<BaseInput
						ref="BaseInput.regularLicensePlate.thirdPart"
						:required="required"
						@input="updateValue"
						label=""
						placeholder="5480"
						class="mb-0 w-full"
						type="tel"
						:error-message="$t('check_field')"
						maxlength="4"
						v-model="regularLicensePlate.thirdPart"
						validation="^([0-9]{1,4}$)|([0-9]{1,4}[Ee]$)"
						mask="NEEEE"
						:disabled="disabled"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import Validate from '@/mixins/Validate';
import BaseSelect from '@/components/forms/inputs/BaseSelect';

export default {
	name: 'LicensePlateInput',
	mixins: [Validate],
	components: { BaseSelect, BaseInput },
	inheritAttrs: false,
	props: {
		value: {},
		disabled: { type: Boolean },
		showOnly: { type: String, default: '' },
		display: {},
		required: {
			default: true,
		},
	},
	data() {
		return {
			init: false,
			specialLicensePlate: null,
			regularLicensePlate: {
				firstPart: null,
				secondPart: null,
				thirdPart: null,
			},
			licensePlateSelection: null,
			options: [
				{ display: this.$t('regular_plate'), value: false },
				{ display: this.$t('special_plate'), value: true },
			],
		};
	},
	computed: {
		isSpecialPlate() {
			return this.licensePlateSelection?.value;
		},
	},
	mounted() {
		this.updateLicensePlate();
		if (this.specialLicensePlate) {
			this.licensePlateSelection = this.options[1];
		} else {
			this.licensePlateSelection = this.options[0];
		}
	},
	methods: {
		updateValue() {
			this.$emit('input', {
				isSpecial: this.isSpecialPlate,
				text: this.getLicensePlate(),
			});
		},
		getLicensePlate: function() {
			if (this.isSpecialPlate) {
				return this.specialLicensePlate;
			}
			const plate = this.regularLicensePlate;
			return (plate.firstPart ?? '') + ' ' + (plate.secondPart ?? '') + ' ' + (plate.thirdPart ?? '').trim();
		},
		updateLicensePlate() {
			const text = this.value?.text;

			if (text && text?.trim()) {
				if (this.value.isSpecial) {
					this.licensePlateSelection = this.options[1];
					this.specialLicensePlate = text;
				} else if (this.value.isSpecial !== undefined) {
					const plate = text.split(' ');

					this.licensePlateSelection = this.options[0];
					this.regularLicensePlate.firstPart = plate[0];
					this.regularLicensePlate.secondPart = plate[1];
					this.regularLicensePlate.thirdPart = plate[2];
				}
			}
		},
	},
	watch: {
		value() {
			if (!this.init) {
				this.updateLicensePlate();
				this.init = true;
			}
		},
		display() {
			this.updateLicensePlate();
		},
	},
};
</script>
